'use strict';

exports.__esModule = true;

var _errors = require('./errors');

var _errors2 = _interopRequireDefault(_errors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleResponse = function handleResponse(response) {
  if (response.headers.get('content-length') === '0' || response.status === 204) {
    return response.ok ? null : Promise.reject((0, _errors2.default)(response.statusText ? response.statusText : 'Request failed'));
  }

  var json = response.json();

  return response.ok ? json : json.then(function (cause) {
    return Promise.reject((0, _errors2.default)(cause));
  });
};

exports.default = handleResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/handleResponse.js
// module id = 689
// module chunks = 0